import { addLocaleData } from 'react-intl';
import es from 'react-intl/locale-data/es';
import navLocaleData from '@99designs/common/apps/global-nav/locale-data/es';
import { setTranslations as setNavTranslations } from '@99designs/common/apps/global-nav/locale-data';

setNavTranslations(navLocaleData);
addLocaleData(es);



// WEBPACK FOOTER //
// ./src/js/locale-data/es.js